export class User {
    constructor(props) {
        this._fullName = props.fullName;
        delete props.fullName;
        Object.assign(this, props);
    }
    get fullName() {
        if (this._fullName)
            return this._fullName;
        if (this.firstName && this.lastName) {
            return `${this.firstName} ${this.lastName}`;
        }
        return this.firstName;
    }
    get displayName() {
        if (this.firstName)
            return this.firstName;
        if (this.username)
            return this.username;
        if (this.lastName)
            return this.lastName;
        if (this._fullName)
            return this._fullName;
        return this.email;
    }
}
//# sourceMappingURL=User.js.map